// frontend/src/features/bapb/sections/IncomeActualsSection.jsx
import React from "react";
import IncomeBasic from "./IncomeBasic";

export default function IncomeActualsSection(props) {
  // Basic Actuals saves under data.income_actuals
  return <IncomeBasic {...props} dataKey="income_actuals" />;
}
